import React from 'react';
import { useParams } from 'react-router-dom';
import { useField } from 'formik';
import { pathOr } from 'ramda';
import PropTypes from 'prop-types';

import { GENERATE_PRESCRIPTION } from 'store/diagnoses';
import { NURSING_HOME, usePatient } from 'store/patients';
import { ISSUES_PRESCRIPTIONS, SUB_ORGANIZATION } from 'store/organizations';
import QuestionContainer from 'components/QuestionContainer';
import YesNoQuestion from 'components/YesNoQuestion';
import Warning from 'components/Warning';

export default function CreationForm({ readMode }) {
  const { id } = useParams();
  const issuesPrescriptions = pathOr(false, [SUB_ORGANIZATION, ISSUES_PRESCRIPTIONS], usePatient(id, NURSING_HOME));
  const [{ value: generatePrescription }, , { setValue: setGeneratePrescription }] = useField(GENERATE_PRESCRIPTION);

  return (
    <QuestionContainer label="Rezept erstellen">
      <YesNoQuestion
        value={generatePrescription}
        question="Möchten Sie ein Rezept ausstellen?"
        onChoose={setGeneratePrescription}
        readMode={readMode}
        withoutBorder
      />
      {issuesPrescriptions && <Warning>Das Pflegeheim stellt Rezepte normalerweise selber aus.</Warning>}
    </QuestionContainer>
  );
}

CreationForm.propTypes = { readMode: PropTypes.bool.isRequired };
